import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
const TAKEN_STATUSES = ['connect', 'transfer', 'domainTakenInWix', 'upgradeRequireConnect', 'upgradeRequireTransferIn'];
export const useIsSubmittedDomainTaken = () => {
  const status = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.useStatus();
  return Boolean(status && TAKEN_STATUSES.includes(status));
};
//# sourceMappingURL=useIsSubmittedDomainTaken.js.map